import { render, staticRenderFns } from "./academic_activity.vue?vue&type=template&id=5f010d70&scoped=true"
import script from "./academic_activity.vue?vue&type=script&lang=js"
export * from "./academic_activity.vue?vue&type=script&lang=js"
import style0 from "./academic_activity.vue?vue&type=style&index=0&id=5f010d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f010d70",
  null
  
)

export default component.exports